// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultIcon_container__7Y-Ky"};